import React, { Component } from "react";

import { CCol, CRow } from "@coreui/react";
import {
  RiAccountCircleFill,
  RiAlertFill,
  RiBillLine,
  RiCalendarTodoFill,
  RiDossierFill,
  RiGroupFill,
  RiLayoutMasonryFill,
  RiTeamFill,
  RiArticleFill
} from "react-icons/ri";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import avaliandoPng from "./avaliando.png";
import { logout } from "../../../actions/baseActions";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import AdminDashboardButton from "../../AdminDashboardButton";

const AvaliandoIconComponent = ({ size, className }) => (
  <img
    src={avaliandoPng}
    alt="Avaliando"
    className={className}
    style={{
      width: size,
      height: size,
      objectFit: "contain"
    }}
  />
);

class DashboardAdministrador extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // dashboard: {
      //   cards: {},
      //   schedule: null,
      //   today: null,
      //   rooms: [],
      //   classrooms: []
      // },
      primaryColor: null,
      secondaryColor: null,
      grayColor: null
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  componentDidMount() {
    const id = this.props.general.active_roles.group_id;
    if (id != null) {
      axios
        .get(`${URL.api}access/group/singleView/${id}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(respmodule => {
          this.setState(() => ({
            primaryColor: respmodule.data.data.group.primary,
            secondaryColor: respmodule.data.data.group.secondary,
            grayColor: respmodule.data.data.group.primary_grey
          }));
        });
    }
  }

  getBorder(item) {
    if (item.activity_percentage) return "light";
    if (Date.parse(item.activity_end) < Date.now()) return "danger";
    return "primary";
  }

  group(notices, activities) {
    let months = [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez"
    ];
    let days = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

    // let myArray = [...notices, ...activities];
    let myArray = [...activities];

    myArray.sort((a, b) => {
      let c = new Date(a.activity_start ? a.activity_start : a.created_at);
      let d = new Date(b.activity_start ? b.activity_start : b.created_at);
      return d - c;
    });

    let groups = myArray.reduce((r, o) => {
      if (o.activity_start) {
        o = { ...o, activity: true };
      } else {
        o = { ...o, activity: false };
      }

      const dt = new Date(o.activity_start ? o.activity_start : o.created_at);

      let m = `${days[dt.getDay()]}/${`00${dt.getDate()}`.slice(-2)}/${
        months[dt.getMonth()]
      }/${dt.getFullYear()}`;
      r[m] ? r[m].data.push(o) : (r[m] = { group: m, data: [o] });
      return r;
    }, {});

    let result = Object.keys(groups).map(k => groups[k]);

    return result;
  }

  friendlyDate(date) {
    const dt = new Date(date);

    return `${`00${dt.getDate()}`.slice(-2)}/${`00${dt.getMonth() + 1}`.slice(
      -2
    )} ${`00${dt.getHours()}`.slice(-2)}:${`00${dt.getMinutes()}`.slice(-2)}`;
  }

  render() {
    const root = document.documentElement;

    root?.style.setProperty(
      "--primary-group-change",
      this.state.primaryColor != null ? this.state.primaryColor : ""
    );
    root?.style.setProperty(
      "--secondary-group-change",
      this.state.secondaryColor != null ? this.state.secondaryColor : ""
    );
    root?.style.setProperty(
      "--primary-grey-group-change",
      this.state.grayColor != null ? this.state.grayColor : ""
    );

    let isConstruir =
      this.props.general.active_roles.group_id === 45 ||
      this.props.general.active_roles.group_id === 92;

    if (isConstruir) {
      return (
        <div className="h-100 d-flex flex-column flex-1">
          <h2 className="font-weight-bold text-title mb-3">Menu inicial</h2>
          <CRow className="flex-1">
            <CCol
              xs="12"
              sm="4"
              className="mb-4 d-flex justify-content-center align-items-center"
            >
              <AdminDashboardButton
                icon={RiLayoutMasonryFill}
                title="Recursos"
                view="content/list/0"
                color="#C99678"
              />
            </CCol>
            <CCol
              xs="12"
              sm="4"
              className="mb-4 d-flex justify-content-center align-items-center"
            >
              <AdminDashboardButton
                icon={RiAlertFill}
                title="Avisos"
                view="notice/list"
                create="notice/form"
                color="#EFC261"
              />
            </CCol>
            <CCol
              xs="12"
              sm="4"
              className="mb-4 d-flex justify-content-center align-items-center"
            >
              <AdminDashboardButton
                icon={RiDossierFill}
                title="Helpdesk"
                view="helpdesk"
                color="#E36767"
              />
            </CCol>
          </CRow>
        </div>
      );
    }

    return (
      <div className="h-100 d-flex flex-column flex-1">
        <h2 className="font-weight-bold text-title mb-3">Menu inicial</h2>
        <CRow className="flex-1">
          <CCol
            xs="12"
            sm="4"
            className="mb-4 d-flex justify-content-center align-items-center"
          >
            <AdminDashboardButton
              icon={RiAccountCircleFill}
              title="Usuários"
              view="Userlist"
              create="user/cadastro"
              color="#5187A2"
            />
          </CCol>
          <CCol
            xs="12"
            sm="4"
            className="mb-4 d-flex justify-content-center align-items-center text-center"
          >
            <AdminDashboardButton
              icon={AvaliandoIconComponent}
              title="Avaliando Conhecimentos"
              view="adr/external-login"
              color="#80A1A3"
            />
          </CCol>
          <CCol
            xs="12"
            sm="4"
            className="mb-4 d-flex justify-content-center align-items-center"
          >
            <AdminDashboardButton
              icon={RiCalendarTodoFill}
              title="Agenda"
              view="notice/me"
              color="#AF60A7"
            />
          </CCol>
        </CRow>
        <CRow className="flex-1">
          <CCol
            xs="12"
            sm="4"
            className="mb-4 d-flex justify-content-center align-items-center"
          >
            <AdminDashboardButton
              icon={RiGroupFill}
              title="Turmas"
              view="classroom/list"
              create="classroom/form"
              color="#988FE9"
            />
          </CCol>
          <CCol
            xs="12"
            sm="4"
            className="mb-4 d-flex justify-content-center align-items-center"
          >
            <AdminDashboardButton
              icon={RiAlertFill}
              title="Avisos"
              view="notice/list"
              create="notice/form"
              color="#EFC261"
            />
          </CCol>
          <CCol
            xs="12"
            sm="4"
            className="mb-4 d-flex justify-content-center align-items-center"
          >
            <AdminDashboardButton
              icon={RiArticleFill}
              title="Atividades"
              view="activity/list"
              create="activity/create"
              color="#00BE90"
            />
          </CCol>
        </CRow>
        <CRow className="flex-1">
          <CCol
            xs="12"
            sm="4"
            className="mb-4 d-flex justify-content-center align-items-center"
          >
            <AdminDashboardButton
              icon={RiLayoutMasonryFill}
              title="Recursos"
              view="content/list/0"
              color="#C99678"
            />
          </CCol>
          <CCol
            xs="12"
            sm="4"
            className="mb-4 d-flex justify-content-center align-items-center"
          >
            <AdminDashboardButton
              icon={RiBillLine}
              title="Avaliações"
              view="evaluation/adr/list"
              create="evaluation/adr/create"
              color="#C99678"
            />
          </CCol>
          <CCol
            xs="12"
            sm="4"
            className="mb-4 d-flex justify-content-center align-items-center"
          >
            <AdminDashboardButton
              icon={RiDossierFill}
              title="Helpdesk"
              view="helpdesk"
              color="#E36767"
            />
          </CCol>
        </CRow>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardAdministrador);
